import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { IGeneralPlacementTest } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { GENERAL_PLACEMENT_TEST } from 'src/app/dummy/testing';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';

@Component({
  selector: 'app-add-mcq-general-placement',
  templateUrl: './add-mcq-general-placement.component.html',
  styleUrls: ['./add-mcq-general-placement.component.scss']
})
export class AddMcqGeneralPlacementComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  form: FormGroup;
  equation: any = '';

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new answer';
  GENERAL_PLACEMENT_TEST = GENERAL_PLACEMENT_TEST;

  constructor(
    public dialogRef: MatDialogRef<AddMcqGeneralPlacementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: PlacementTest,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private router: Router,
  ) { }

  ngOnInit() {
    const { QUESTION } = this.data;
    this.form = this.fb.group({
      answer: [QUESTION ? QUESTION.question : null, Validators.compose([Validators.required, this.onExercise.bind(this)])],
      isCorrect: [false, Validators.required],
    })
    if (QUESTION) {
      this.TITLE = "Edit answer";
    }
  }

  onExercise(control: AbstractControl) {
    if (control && control.value) {
      const { value } = control;
      this.equation = value;
    }
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { answer, isCorrect } = f;
      const { FORM, ITEM, QUESTION, SKILL_KEY, CLASS_KEY } = this.data;
      const { question, exercise } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const questions = ITEM ? ITEM.questions : []
      const row = {
        key: QUESTION ? QUESTION.key : this.ds.createId(),
        answer,
        isCorrect
      };
      const ANSWER_DATA = pushObjArray(questions, row)
      const registerStatus = STATUS_OBJECT.submitted;

      const activity: IGeneralPlacementTest = {
        key: ITEM ? ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: ITEM ? ITEM.organizationKey : selectedCompanyKey,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        question: question || null,
        exercise: exercise || null,
        questions: ANSWER_DATA,
        skillKey: SKILL_KEY,
        classKey: CLASS_KEY,
        classRef: this.ds.generalPlacementTestRef().doc(CLASS_KEY).ref,
      }
      this.store.addMCQ(activity, (success, res) => {
        this.data.ITEM = activity;
        this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
        if (!isNew) {
          this.dialogRef.close('no')
          this.router.navigate([`/testing-center/general-placement-test/${SKILL_KEY}/${CLASS_KEY}/${activity.key}`])
          return;
        }
        this.form.reset();
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.isCreate = false;
        this.equation=''
        this.inputEl.nativeElement.focus();
        this.form.patchValue({ isCorrect: false })
        this.router.navigate([`/testing-center/general-placement-test/${SKILL_KEY}/${CLASS_KEY}/${activity.key}`])
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}